var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 44 44","aria-labelledby":_vm.nombreIcono,"role":"presentation"}},[_c('g',{attrs:{"fill":_vm.colorIcono}},[_c('path',{attrs:{"d":_vm.value}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67dd71a3","hasScoped":true,"buble":{"transforms":{}}}!./src/components/Icono/Icono.html
// module id = 683
// module chunks = 0